export enum PurchaseCostFormStep {
  Details = 0,
  ShippingTerms = 1,
}
